module.exports = __webpack_public_path__ + "static/img/jinsaiyaoye.0df87dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/jinsaiyaoye.jpg
// module id = CIht
// module chunks = 0